var _rect, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 71,
    height: 71,
    rx: 10,
    fill: "#87cbfe",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1769",
    "data-name": "Grupo 1769",
    transform: "translate(16.16 16.459)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-149",
    "data-name": "Stroke 1-149",
    transform: "translate(18.686 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    "data-name": "Caminho 428",
    d: "M919.831,458.621a1.516,1.516,0,0,1-1.515-1.515V432.782a1.515,1.515,0,1,1,3.03,0v24.324A1.516,1.516,0,0,1,919.831,458.621Z",
    transform: "translate(-918.316 -431.267)",
    fill: "#87cbfe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-123",
    "data-name": "Stroke 3-123",
    transform: "translate(12.796 18.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    "data-name": "Caminho 429",
    d: "M922.8,449.325a1.511,1.511,0,0,1-1.073-.446l-5.89-5.915a1.515,1.515,0,1,1,2.147-2.137l4.816,4.836,4.818-4.836a1.515,1.515,0,1,1,2.147,2.137l-5.89,5.915A1.512,1.512,0,0,1,922.8,449.325Z",
    transform: "translate(-915.401 -440.38)",
    fill: "#87cbfe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1767",
    "data-name": "Grupo 1767",
    transform: "translate(0 22.186)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    "data-name": "Caminho 430",
    d: "M940.539,457.38H918.017a8.96,8.96,0,0,1-8.951-8.949v-4.666a1.515,1.515,0,1,1,3.03,0v4.666a5.926,5.926,0,0,0,5.921,5.919h22.522a5.9,5.9,0,0,0,5.9-5.9v-4.687a1.515,1.515,0,1,1,3.03,0v4.687A8.937,8.937,0,0,1,940.539,457.38Z",
    transform: "translate(-909.066 -442.25)",
    fill: "#87cbfe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ff3b6752c387baf53d8f16ecf4f34f8c.svg";
export { ForwardRef as ReactComponent };